import {filterModels} from "@/DATA/functions";
import resources from "@/DATA/resources";
import activities from "@/DATA/activities";

const learning_paths = [


    // Built In Paths

    {
        id: 1,
        name: 'Professional Development',
        icon: '/images/icons/icon-path-dark.svg',
        owner: 'dfc',
        stages: {

            feel: {
                name: 'Feel',
                color: '#ee1651',
                mission: {
                    questions: [
                        {
                            title: 'Skill',
                            hint: 'Build empathy and understanding in order to  >',
                        }, {
                            title: 'Outcome',
                            hint: 'Select specific issue',
                        }, {
                            title: 'Description',
                            hint: 'Students identify the root cause of an issue around which they want to focus their project',
                        }
                    ],
                    lesson_plan: {
                        description: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam.',
                        full_description: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam.',
                        file: {
                            url: 'http://www.africau.edu/images/default/sample.pdf',
                        }
                    }
                },

                resources: [
                    resources[0],
                    resources[1],
                    resources[2],
                ],

                activity_sections: [
                    {
                        id: 1,
                        name: 'Build Empathy',
                        description: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.',
                        activities: [
                            activities[0],
                        ],
                    },
                    {
                        id: 2,
                        name: 'Analyze the Issue',
                        description: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.',
                        activities: [
                            activities[1],
                        ],
                    },
                ]
            },


            imagine: {
                name: 'Imagine',
                color: '#ff771a',
                mission: {
                    questions: [
                        {
                            title: 'Skill',
                            hint: 'Engage in divergent, creative thinking so that > ',
                        }, {
                            title: 'Outcome',
                            hint: 'Select idea for action ("solution")',
                        }, {
                            title: 'Description',
                            hint: 'Students identify the aligned action they want to take in their project',
                        }
                    ],
                    lesson_plan: {
                        description: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam.',
                        full_description: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam.',
                        file: {
                            url: 'http://www.africau.edu/images/default/sample.pdf',
                        }
                    }
                },

                resources: [
                    resources[0],
                    resources[1],
                    resources[2],

                ],

                activity_sections: [
                    {
                        id: 2,
                        name: 'Frame the Question',
                        description: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.',
                        activities: [
                            activities[2],
                        ],
                    },
                    {
                        id: 2,
                        name: 'Brainstorm Ideas',
                        description: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.',
                        activities: [
                            activities[3],
                        ],
                    },
                    {
                        id: 2,
                        name: 'Select an Idea',
                        description: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.',
                        activities: [
                            activities[4],
                            activities[5],
                        ],
                    },
                ]
            },


            do: {
                name: 'Do',
                color: '#41BC97',
                mission: {
                    questions: [
                        {
                            title: 'Skill',
                            hint: 'Create an action plan in order to >',
                        }, {
                            title: 'Outcome',
                            hint: 'Implement a change project',
                        }, {
                            title: 'Description',
                            hint: 'Students determine the steps they will take to carry out their action plaan',
                        }
                    ],
                    lesson_plan: {
                        description: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam.',
                        full_description: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam.',
                        file: {
                            url: 'http://www.africau.edu/images/default/sample.pdf',
                        }
                    }
                },

                resources: [
                    resources[0],
                    resources[1],
                    resources[2]
                ],

                activity_sections: [

                    {
                        id: 2,
                        name: 'Develop a Plan',
                        description: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.',
                        activities: [
                            activities[6],
                        ],
                    },
                    {
                        id: 2,
                        name: 'Get Feedback and Reflect',
                        description: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.',
                        activities: [
                            activities[7],
                        ],
                    },
                    {
                        id: 2,
                        name: 'Develop a Plan',
                        description: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.',
                        activities: [
                            activities[8],
                        ],
                    },
                    {
                        id: 2,
                        name: 'Get Feedback and Reflect',
                        description: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.',
                        activities: [
                            activities[9],
                        ],
                    },
                ]
            },

            share: {
                name: 'Share',
                color: '#00B2E3',
                mission: {
                    questions: [
                        {
                            title: 'Skill',
                            hint: 'Reflect on changemaking >',
                        }, {
                            title: 'Outcome',
                            hint: 'Identify lessons learned and inspire additional action',
                        }, {
                            title: 'Description',
                            hint: 'Students make meaning of the changemaking process and their project and determine how to tell their story of change',
                        }
                    ],
                    lesson_plan: {
                        description: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam.',
                        full_description: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam.',
                        file: {
                            url: 'http://www.africau.edu/images/default/sample.pdf',
                        }
                    }
                },

                resources: [
                    resources[0],
                    resources[1],
                    resources[2],

                ],

                activity_sections: [
                    {
                        id: 2,
                        name: 'Make Meaning',
                        description: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.',
                        activities: [
                            activities[10],
                        ],
                    },
                ]
            },
        }


    },

    {
        id: 7,
        name: 'DFC Path 01',
        icon: '/images/icons/icon-path-dark.svg',
        owner: 'dfc',
    },
    {
        id: 8,
        name: 'DFC Path 02',
        icon: '/images/icons/icon-path-dark.svg',
        owner: 'dfc',
    },


    // Custom Paths

    {
        id: 2,
        name: 'My Custom Path',
        icon: '/images/icons/icon-path-dark.svg',
        owner: 'user',
    },


];

export const custom = filterModels(learning_paths, {owner: 'user'});
export const built_in = filterModels(learning_paths, {owner: 'dfc'});

export default learning_paths;
